import Notification from '@/models/Notifications/Notification'

export interface NotificationContent {
  title: string
  description: string
}

interface NotificationContentGenerators {
  user_login: (notification: Notification) => NotificationContent
  user_password_set: (notification: Notification) => NotificationContent
  user_password_change: (notification: Notification) => NotificationContent
  user_password_reset: (notification: Notification) => NotificationContent
}

const generators = {
  user_login (notification: Notification) {
    return {
      title: 'В ваш аккаунт был произведен вход',
      description: 'Был произведен вход с устройства ' + notification.getParams().ips
    }
  },
  user_password_set (notification: Notification) {
    return {
      title: 'Пароль был изменен',
      description: 'Администратор изменил ваш пароль'
    }
  },
  user_password_change (notification: Notification) {
    return {
      title: 'Пароль был изменен',
      description: 'Вы изменил свой пароль'
    }
  },
  user_password_reset (notification: Notification) {
    return {
      title: 'Пароль был изменен',
      description: 'Ваш пароль был сброшен через форму восстановления пароля'
    }
  },
  user_appoint(notification: Notification) {
    let title = 'Новая запись на прием'
    let description = notification.getParams().date + ' ' + notification.getParams().time + '. ' +
      notification.getParams().name + ', ' + notification.getParams().age + '. ' +
      notification.getParams().org + ', ' + notification.getParams().address + ', ' + notification.getParams().cabinet + '. ' +
      notification.getParams().service + ', ' + notification.getParams().price
    return {title, description}
  },
  default (notification: Notification) {
    return {
      title: 'Уведомление',
      description: notification.getParams()
    }
  }
}

export function makeNotification (notification: Notification) {
  let generator = generators[notification.getType() as keyof NotificationContentGenerators] ? generators[notification.getType() as keyof NotificationContentGenerators] : generators.default
  return generator(notification)
}